import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSortModule } from '@angular/material/sort';
import { FormsModule } from '@angular/forms';
import { NoctemLibModule } from '@noctem/web';
import { SharedModule } from './../../shared/shared.module';
import { LayoutModule } from '../../layout/layout.module';
import { ReportingComponent } from './reporting.component';

const routes: Routes = [
    { path: '', component: ReportingComponent },
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatCheckboxModule,
        MatProgressBarModule,
        FormsModule,
        NoctemLibModule,
        SharedModule,
        LayoutModule
    ],
    declarations: [
        ReportingComponent,
    ],
    exports: [
        RouterModule
    ],
})
export class ReportingModule { }
